import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import * as staffService from "../../services/subadmin.services";
import Breadcrums from "../../common/breadcrumbs";
import Loader from "../../common/loader";
import { capitalizeFirstLetter, formateDateWithMonth, removeSpecialCharacter } from "../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
import { Placeholder } from "rsuite";
const ViewSubAdmin = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  // const [query] = useSearchParams();
  const [showdefault, setShowDefault] = useState({});
  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    { title: t("label_sub_admin"), url: "/admin/staff/list/1" },
    { title: t("btn_view"), url: "" },
  ];


  useEffect(() => {
    staffService.Details(params.id).then(response => {
      setShowDefault(response && response.data ? response.data : [])
    }).catch(error => {
      console.log("error=====>", error)
    })
  }, [])

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <div>
                <h6 className="main-content-label mb-3">
                  {t("View Sub Admin Details")}
                </h6>
              </div>
              {showdefault && Object.keys(showdefault).length > 0 ? (
                <div className="row">
                  <div className="col-lg-12 form-group">
                    <table
                      id="simple-table"
                      className="table  table-bordered table-hover"
                    >
                      <tbody>
                        <tr>
                          <th>{t("Profile Image")}</th>
                          <td><img src={showdefault && showdefault.profile_image ? showdefault.profile_image : ""} alt={showdefault?.first_name} style={{ height: "100px" }} /></td>
                        </tr>
                        <tr>
                          <th>{t("First Name")}</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault?.first_name
                              ? capitalizeFirstLetter(showdefault?.first_name)
                              : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("Last Name")}</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault?.last_name
                              ? capitalizeFirstLetter(showdefault?.last_name)
                              : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th className="text-capitalize">{t("Email")}</th>
                          <td>
                            {showdefault && showdefault?.email
                              ? (showdefault?.email)
                              : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>Role</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault?.permission_role
                              ? capitalizeFirstLetter(showdefault?.permission_role?.title)
                              : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("label_permissions")}</th>
                          <td>
                            {showdefault?.permission_role?.permissions?.length > 0 ? (
                              <ul className="mb-0 pl-3">
                                {showdefault.permission_role.permissions.map((p, idx) => (
                                  <li key={idx}>
                                    {typeof p === "object"
                                      ? p.title || p.shortSlug || p._id || "—"
                                      : String(p)}
                                  </li>
                                ))}
                              </ul>
                            ) : (
                              "N/A"
                            )}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("Created Date")}</th>
                          <td>
                            {showdefault && showdefault.createdAt
                              ? formateDateWithMonth(showdefault.createdAt)
                              : "N/A"}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
                <Placeholder.Paragraph className="w-100 admin-placeholder" rowHeight={30} rowSpacing={5} active={true} rows={7} />
              )}
            </div>


            <div className="mt-5 back-button">
              <button
                className="btn ripple btn-dark"
                type="button"
                onClick={() =>
                  navigate("/admin/staff/list/1")
                }
              >
                <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                {t("btn_back")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewSubAdmin;
